import {responseInterface, urlsInterface} from "@/types";
import {
  httpClient,
  HttpClientGetParameters
} from "@/apiClient/models/http/httpClient.models";

export interface CategoriesApiClientInterface {
  fetch: (lang?: string) => Promise<responseInterface>;
}

export class CategoriesApi implements CategoriesApiClientInterface {
  private readonly urls!: urlsInterface;

  constructor(urls: urlsInterface) {
    this.urls = urls;
  }

  fetch(lang?: string): Promise<responseInterface> {
    const url = this.urls.fetch.replace("{%lang%}", lang as string);
    const getParameters: HttpClientGetParameters = { url, requiresToken: false };

    return httpClient.get<responseInterface>(getParameters);
  }
}
